module.exports = __webpack_public_path__ + "img/mono_11.c3370ec7.png";